<template>
  <el-footer style="height: 25px">
    <div class="copyright">
      Copyright © {{ SYS.copyright }}
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">{{
        SYS.beianID
      }}</a>
    </div>
  </el-footer>
</template>

<script>
export default {};
</script>

<style lang="less">
.copyright {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  height: 25px;
  line-height: 25px;
  a {
    font-size: 12px;
    color: #ccc;
    text-decoration: none;
  }
}
</style>